import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Participa from "../../components/Participa/Participa";

import "./Botiga.css";

import shop1img from "../../assets/images/botiga/shop1.png";
import shop2img from "../../assets/images/botiga/shop2.png";
import shop3img from "../../assets/images/botiga/shop3.png";

// Registramos el plugin ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

function Botiga() {
  // Referencias para los elementos de la galería
  const galleryRefs = [useRef(null), useRef(null), useRef(null)];

  // Configuramos diferentes velocidades y distancias para cada imagen
  const animations = [
    { speed: 0.1, distance: 20 },
    { speed: 0.5, distance: 250 },
    { speed: 0.2, distance: 100 },
  ];

  useGSAP(() => {
    galleryRefs.forEach((ref, index) => {
      gsap.to(ref.current, {
        y: animations[index].distance,
        ease: "none",
        scrollTrigger: {
          trigger: ref.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          speed: animations[index].speed,
        },
      });
    });
  }, []);

  return (
    <>
      <section className="botiga">
        <div className="botiga__section">
          <div className="botiga__section-text">
            <h1>MARXANDATGE</h1>
            <p>
              Aquí podeu veure el marxandatge del casal i/o de les entitats que
              en formen part. No disposem de botiga en línia, si voleu
              marxandatge del casal envieu-nos un correu electrònic o veniu
              presencialment al casal i en parlem!
            </p>
          </div>
        </div>

        <div className="botiga__first-gallery">
          {[1, 2, 3].map((num, index) => (
            <div
              key={num}
              ref={galleryRefs[index]}
              className={`botiga__gallery-item botiga__gallery-item--${num}`}
            ></div>
          ))}
        </div>

        <div className="botiga__second-gallery">
          <div
            className="botiga__static-item"
            style={{
              backgroundImage: `url(${shop1img})`,
            }}
          ></div>
          <div
            className="botiga__static-item"
            style={{
              backgroundImage: `url(${shop2img})`,
            }}
          ></div>
          <div
            className="botiga__static-item"
            style={{
              backgroundImage: `url(${shop3img})`,
            }}
          ></div>
        </div>
      </section>
      <Participa />
    </>
  );
}

export default Botiga;
